import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, Activity, Heart } from 'lucide-react';
const benefits = [{
  icon: <Shield className="w-8 h-8 text-leaf" data-id="element-8" />,
  title: 'Alto en Antioxidantes',
  description: 'Protege tus células y combate el envejecimiento prematuro gracias a su riqueza en compuestos bioactivos.'
}, {
  icon: <Zap className="w-8 h-8 text-leaf" data-id="element-9" />,
  title: 'Rico en Vitaminas',
  description: 'Una fuente excelente de Vitamina C y K, esenciales para la inmunidad y la salud ósea.'
}, {
  icon: <Activity className="w-8 h-8 text-leaf" data-id="element-10" />,
  title: 'Propiedades Digestivas',
  description: 'Su alto contenido en fibra y opciones fermentadas promueven un microbioma intestinal saludable.'
}, {
  icon: <Heart className="w-8 h-8 text-leaf" data-id="element-11" />,
  title: 'Antiinflamatorio Natural',
  description: 'Ayuda a reducir la inflamación en el cuerpo, contribuyendo a una mejor salud general.'
}];
export function Benefits() {
  return <section className="py-12 md:py-24 relative overflow-hidden text-cream" style={{
    background: 'linear-gradient(135deg, #5B2C6F 0%, #7D3C98 35%, #27AE60 75%, #1A5632 100%)'
  }} data-id="element-12">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 -mt-24 -mr-24 w-96 h-96 bg-cabbage rounded-full blur-3xl opacity-30" data-id="element-13"></div>
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-leaf-dark rounded-full blur-3xl opacity-25" data-id="element-14"></div>

      {/* Julienne texture */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" data-id="element-15">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-16">
          <defs data-id="element-17">
            <pattern id="julienne-benefits" x="0" y="0" width="65" height="45" patternUnits="userSpaceOnUse" patternTransform="rotate(-20)" data-id="element-18">
              <path d="M0 22 Q16 17, 32 22 T65 22" fill="none" stroke="#fff" strokeWidth="1.5" opacity="0.5" data-id="element-19" />
              <path d="M0 8 Q16 3, 32 8 T65 8" fill="none" stroke="#fff" strokeWidth="1" opacity="0.3" data-id="element-20" />
              <path d="M0 36 Q16 31, 32 36 T65 36" fill="none" stroke="#fff" strokeWidth="1" opacity="0.3" data-id="element-21" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#julienne-benefits)" data-id="element-22" />
        </svg>
      </div>

      <div className="container mx-auto px-5 md:px-6 max-w-6xl relative z-10" data-id="element-23">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center" data-id="element-24">
          <div className="md:w-1/3 text-center md:text-left" data-id="element-25">
            <motion.h2 initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-3xl md:text-5xl font-serif mb-4 md:mb-6 text-white" data-id="element-26">
              Más que un ingrediente.
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="text-white/80 text-base md:text-lg leading-relaxed" data-id="element-27">
              Además de su increíble versatilidad culinaria, el repollo es un
              superalimento accesible que transforma cada comida en una
              inversión para tu salud.
            </motion.p>
          </div>

          <div className="md:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6" data-id="element-28">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-cabbage-dark/60 backdrop-blur-sm p-5 md:p-6 rounded-2xl border border-cabbage/40 hover:border-cabbage/70 transition-all duration-300" data-id="element-29">
                <div className="bg-cabbage/30 w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center mb-3 md:mb-4" data-id="element-30">
                  {benefit.icon}
                </div>
                <h3 className="text-lg md:text-xl font-serif text-white mb-1 md:mb-2" data-id="element-31">
                  {benefit.title}
                </h3>
                <p className="text-white/70 text-xs md:text-sm leading-relaxed" data-id="element-32">
                  {benefit.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}